<template>
  <asc-page-loading-indicator
    :loading="isDataLoading && apiPageFailure.length === 0"
  >
    <div class="asc-user-profile-container">
      <v-container fluid>
        <asc-page-header>
          <template #pageTitle
            ><asc-page-title title="USER PROFILE"
          /></template>
        </asc-page-header>
        <asc-user-profile-template :user-profile="profile" />
      </v-container>
    </div>
  </asc-page-loading-indicator>
</template>

<script>
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import { AscUserProfileTemplate } from '@/components/templates'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'

import { mapActions, mapState } from 'vuex'
import { USER_CONSTS as UC } from '@/stores/consts'

export default {
  name: 'AscUserProfileContainer',

  components: {
    AscPageLoadingIndicator,
    AscUserProfileTemplate,
    AscPageHeader,
    AscPageTitle,
  },

  data() {
    return {
      isDataLoading: false,
    }
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(UC.NAMESPACE, ['profile']),
  },

  mounted() {
    if (!this.profile) this.getUserProfile()
  },

  methods: {
    ...mapActions(UC.NAMESPACE, [UC.GET_USER_PROFILE]),
    async getUserProfile() {
      this.isDataLoading = true
      await this[UC.GET_USER_PROFILE]()
      this.isDataLoading = false
    },
  },
}
</script>

<style lang="scss">
.asc-user-profile-container {
  background-color: $gray-100;

  & .container {
    padding: 16px;
  }
}
</style>
